import React from 'react';
import { AvatarGroup, AvatarGroupProps } from '@mui/material';

interface ICustomAvatarGroup extends AvatarGroupProps {
  customSize?: number;
  customFontSize?: string;
}

export const CustomAvatarGroup: React.FC<ICustomAvatarGroup> = ({
  customSize = 24,
  customFontSize = '0.75rem',
  sx,
  children,
  ...rest
}) => {
  const defaultSx = {
    '& .MuiAvatar-root': {
      width: customSize,
      height: customSize,
      fontSize: customFontSize,
    },
  };

  return (
    <AvatarGroup
      {...rest}
      sx={{
        ...defaultSx,
        ...sx,
      }}
    >
      {children}
    </AvatarGroup>
  );
};
